import { DefaultVoucher, Voucher } from "@/models/voucher";
import { InjectionKey } from "vue";

const paymentsBaseUrl = "https://payments.leasity.cl/api/";

interface VouchersResponse {
  creditorName: string;
  creditorPictureUrl: string;
  creditorTaxId: string;
  vouchers: Voucher[];
}

export enum RequestStatus {
  OK,
  NO_VOUCHERS,
  NO_CREDITOR,
}

export const VOUCHER_SERVICE: InjectionKey<VouchersService> = Symbol();

export class VouchersService {
  private vouchersResponse!: VouchersResponse | undefined;
  private currentVoucher: number;

  constructor() {
    this.currentVoucher = 0;
  }

  getVouchers(taxId: string): Promise<RequestStatus> {
    this.vouchersResponse = undefined;
    return new Promise<RequestStatus>((resolve, reject) => {
      const request = new XMLHttpRequest();

      request.open(
        "GET",
        paymentsBaseUrl + "vouchers?code=" + btoa(taxId),
        true
      );

      request.onreadystatechange = () => {
        if (request.readyState == 4) {
          if (request.status === 200) {
            this.vouchersResponse = JSON.parse(
              request.responseText
            ) as VouchersResponse;

            if (this.vouchersResponse?.vouchers.length > 0) {
              resolve(RequestStatus.OK);
            } else {
              resolve(RequestStatus.NO_VOUCHERS);
            }
          } else {
            if (request.status === 404) {
              resolve(RequestStatus.NO_CREDITOR);
            } else {
              // TODO: Remove
              console.log("GET_ERROR: " + request.status);
              reject(request.status);
            }
          }
        }
      };
      request.send();
    });
  }

  hasMultipleVouchers(): boolean {
    if (this.vouchersResponse === undefined) return false;
    return this.vouchersResponse?.vouchers.length > 1;
  }

  getCurrentVoucher(): Voucher {
    if (
      this.vouchersResponse !== undefined &&
      this.vouchersResponse?.vouchers.length > 0
    ) {
      return this.vouchersResponse?.vouchers[this.currentVoucher];
    }
    return DefaultVoucher;
  }

  nextVoucher(): Voucher {
    this.currentVoucher++;
    if (
      this.vouchersResponse !== undefined &&
      this.currentVoucher >= this.vouchersResponse?.vouchers.length
    ) {
      this.currentVoucher = 0;
    }
    return this.getCurrentVoucher();
  }

  getCreditorName(): string | undefined {
    return this.vouchersResponse?.creditorName;
  }
  getCreditorTaxId(): string {
    if (this.vouchersResponse === undefined) return "";
    return this.vouchersResponse?.creditorTaxId;
  }
}
